import { render, staticRenderFns } from "./ProviderWalletRequests.vue?vue&type=template&id=3bc0200c&scoped=true"
import script from "./ProviderWalletRequests.vue?vue&type=script&lang=js"
export * from "./ProviderWalletRequests.vue?vue&type=script&lang=js"
import style0 from "./ProviderWalletRequests.vue?vue&type=style&index=0&id=3bc0200c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc0200c",
  null
  
)

export default component.exports